<template>
  <component :is="theme.components.BaseElementLayout" :el$="el$">
    <template slot="field">
      <slot name="prefix"></slot>

      <div class="text-xs-center">
        <v-text-field type="hidden" v-model="signature" name="signature" />
        <v-img v-if="signature" :src="signature" style="max-width:80vw" />
        <v-btn @click="requestFullscreen()" color="green" dark slot="activator">
          Signature
        </v-btn>
        <v-bottom-sheet full-width v-model="sheet">
          <v-layout row wrap v-if="sheet">
            <v-flex class="text-xs-center" xs12>
              <v-card>
                <v-card-title class="py-2">
                  {{ title }}
                  <v-spacer></v-spacer>
                  <v-icon @click="sheet = false" color="red" flat>close</v-icon>
                </v-card-title>
                <v-card-text class="py-0 my-0">
                  <VueSignaturePad
                    class="signaturePad"
                    height="60vh"
                    ref="signaturePad"
                    v-if="this.saving === false"
                    width="100%"
                  />
                  <v-progress-circular
                    :size="100"
                    :width="10"
                    color="primary"
                    indeterminate
                    v-else
                  ></v-progress-circular>
                </v-card-text>
                <v-card-actions>
                  <v-btn @click="undo" bottom color="red" dark fab left>
                    <v-icon class="d-flex">undo</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" bottom color="green" dark fab right>
                    <v-icon class="d-flex">save</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-bottom-sheet>
      </div>

      <slot name="suffix"></slot>
    </template>

    <slot slot="label" name="label" :el$="el$"></slot>
    <slot slot="info" name="info" :el$="el$"></slot>
    <slot slot="before" name="before" :el$="el$"></slot>
    <slot slot="between" name="between" :el$="el$"></slot>
    <slot slot="error" name="error" :el$="el$"></slot>
    <slot slot="after" name="after" :el$="el$"></slot>
  </component>
</template>
<script>
import Vue from 'vue'
import VueSignaturePad from 'vue-signature-pad'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseElement from '@laraform/laraform/src/mixins/BaseElement'
import BaseValidation from '@laraform/laraform/src/mixins/BaseValidation'

Vue.use(VueSignaturePad)

export default {
  name: 'SignaturePad',
  mixins: [BaseElement, BaseValidation],
  data: () => ({
    sheet: false,
    isFullscreen: false,
    saving: false,
    signature: null
  }),
  props: ['buttonText', 'title', 'callId', 'onlyEvent', 'signatureType'],
  mounted() {
    //this.$refs.signaturePad.openSignaturePad()
    this.saving = false
  },
  computed: {
    ...mapGetters({
      activeCallId: 'calls/activeCallId'
    })
  },
  methods: {
    ...mapActions({
      addMedia: 'calls/addMedia',
      updateSignature: 'calls/updateSignature'
    }),
    ...mapMutations({
      setNotification: 'root/SET_NOTIFICATION'
    }),
    undo() {
      this.$refs.signaturePad.clearSignature()
    },
    close() {
      this.sheet = false
    },
    save() {
      this.saving = true
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
      this.model = data
      if (!isEmpty) {
        console.log(data)
        this.signature = data
        const media = {}
        media.src = data
        media.type = 'signature'
        const p = {
          callId: this.callId,
          src: data,
          type: this.signatureType || ''
        }
        // Only event is existing, so we are emitting event with signature and care about it in parent component
        this.updateSignature(p)
        this.$emit('form-signature-updated', p)
        this.sheet = false
        this.saving = false
      } else {
        this.setNotification(this.$vuetify.t('$vuetify.calls.signatureEmpty'))
      }
    },
    requestFullscreen() {
      this.isFullscreen = true
      this.sheet = true
    }
  },
  watch: {
    sheet: function() {
      // const lockOrientation = screen.lockOrientation || screen.mozLockOrientation || screen.msLockOrientation || screen.orientation.lock
      if (this.sheet === true) {
        screen.orientation.lock('landscape').catch(function(error) {
          // whatever
          console.log('Landscape error', error)
        })
      } else {
        screen.orientation.lock('natural').catch(function(error) {
          // whatever
          console.log('Natural error', error)
        })
      }
    }
  }
}
</script>
<style scoped>
.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100% !important;
}

.signaturePad {
  border: 1px solid #cccccc;
}
</style>
